import React, { useState } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import { GiReceiveMoney } from "react-icons/gi";
import './provident-fund-history.css'; // Ensure you import the updated CSS file
import ProvidentLayout from '../../components/ProvidentLayout.js';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

export default function ProvidentFundHistory() {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [showTable, setShowTable] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(5); // Set the number of rows per page
  const mockProvidentData = [
    { SR: 1, Name: 'John Doe', Role: 'Employee', Description: 'Sample Description', Date: '2024-08-21' },
    // Add more sample data for pagination testing
    { SR: 2, Name: 'Jane Smith', Role: 'Manager', Description: 'Sample Description 2', Date: '2024-08-22' },
    { SR: 3, Name: 'Mark Johnson', Role: 'Employee', Description: 'Sample Description 3', Date: '2024-08-23' },
    { SR: 4, Name: 'Emily Davis', Role: 'Employee', Description: 'Sample Description 4', Date: '2024-08-24' },
    { SR: 5, Name: 'Michael Brown', Role: 'Manager', Description: 'Sample Description 5', Date: '2024-08-25' },
    { SR: 6, Name: 'Sarah Wilson', Role: 'Employee', Description: 'Sample Description 6', Date: '2024-08-26' },
  ];

  const validateForm = () => {
    const errors = {};
    if (!startDate) errors.startDate = 'Start Date is required';
    if (!endDate) errors.endDate = 'End Date is required';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleGenerateReport = () => {
    if (validateForm()) {
      console.log('Generate Report button clicked');
      setShowTable(true);
    }
  };

  const handleExportToExcel = () => {
    const data = mockProvidentData; // Use your actual data here
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'provident_fund_history.xlsx');
  };

  const handleExportToPDF = () => {
    const doc = new jsPDF();
    const data = mockProvidentData; // Use your actual data here

    doc.text('Provident Fund History', 14, 22);
    doc.autoTable({
      head: [['SR', 'Name', 'Role', 'Description', 'Date']],
      body: data.map(item => [item.SR, item.Name, item.Role, item.Description, item.Date]),
      startY: 30
    });

    doc.save('provident_fund_history.pdf');
  };

  // Pagination functions
  const totalPages = Math.ceil(mockProvidentData.length / rowsPerPage);
  const currentData = mockProvidentData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const pageRange = () => {
    let range = [];
    for (let i = 1; i <= totalPages; i++) {
      range.push(i);
    }
    return range;
  };

  return (
    <ProvidentLayout>
      <div>
        <h1 className="provident-fund-history-header">
          <GiReceiveMoney/>
          Provident Fund History
        </h1>
        <hr className='provident-divider' />

        <Form className="provident-fund-history-form">
          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label htmlFor="start_date">
                  Start date <span className="required">*</span> :
                </Form.Label>
                <Form.Control
                  type="date"
                  id="start_date"
                  name="start_date"
                  required
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  isInvalid={!!formErrors.startDate}
                />
                <Form.Control.Feedback type="invalid">{formErrors.startDate}</Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label htmlFor="end_date">
                  End date <span className="required">*</span> :
                </Form.Label>
                <Form.Control
                  type="date"
                  id="end_date"
                  name="end_date"
                  required
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  isInvalid={!!formErrors.endDate}
                />
                <Form.Control.Feedback type="invalid">{formErrors.endDate}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Button
            className='generate-report-button'
            type='button'
            onClick={handleGenerateReport}
          >
            Generate Report
          </Button>
        </Form>

        {/* Render the table conditionally */}
        {showTable && (
          <div className="provident-fund-history-table-container">
            <div className="table-actions">
              <Row className="w-100">
                <Col xs={12} md={6} className="d-flex align-items-center justify-content-start">
                  <Button variant="secondary" className="export-button" onClick={handleExportToExcel}>Excel</Button>
                  <Button variant="secondary" className="export-button" onClick={handleExportToPDF}>PDF</Button>
                </Col>
                <Col xs={12} md={6} className="d-flex align-items-center justify-content-end">
                  <Form className="d-flex justify-content-end">
                    <Form.Control
                      type="search"
                      placeholder="Search"
                      aria-label="Search"
                      className="search-bar"
                    />
                  </Form>
                </Col>
              </Row>
            </div>
            <div className="table-responsive">
              <table className="table table-striped">
                <thead className="provident-history-table-header">
                  <tr>
                    <th>SR</th>
                    <th>Name</th>
                    <th>Role</th>
                    <th>Description</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.length > 0 ? (
                    currentData.map((item) => (
                      <tr key={item.SR}>
                        <td>{item.SR}</td>
                        <td>{item.Name}</td>
                        <td>{item.Role}</td>
                        <td>{item.Description}</td>
                        <td>{item.Date}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">No data Available Now</td>
                    </tr>
                  )}
                </tbody>
                <tfoot>
                  <tr className="provident-history-table-footer">
                    <td>Total</td>
                    <td>{mockProvidentData.length}</td>
                    <td>0</td>
                    <td>0</td>
                    <td>0</td>
                  </tr>
                </tfoot>
              </table>

              <div className="containerrrr">
                <Row className="custom-row">
                  <Col xs={12} md={9} className="custom-col-left">
                    Showing {(currentPage - 1) * rowsPerPage + 1} to {Math.min(currentPage * rowsPerPage, mockProvidentData.length)} of {mockProvidentData.length} Entries
                  </Col>
                  <Col xs={12} md={3} className="custom-col-right">
                    <nav>
                      <ul className="pagination">
                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                          <a
                            href="/#"
                            className="page-link"
                            onClick={(e) => {
                              e.preventDefault();
                              handlePageChange(currentPage - 1);
                            }}
                          >
                            Previous
                          </a>
                        </li>
                        {pageRange().map(pageNumber => (
                          <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}>
                            <a
                              href="/#"
                              className="page-link"
                              onClick={(e) => {
                                e.preventDefault();
                                handlePageChange(pageNumber);
                              }}
                            >
                              {pageNumber}
                            </a>
                          </li>
                        ))}
                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                          <a
                            href="/#"
                            className="page-link"
                            onClick={(e) => {
                              e.preventDefault();
                              handlePageChange(currentPage + 1);
                            }}
                          >
                            Next
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        )}
      </div>
    </ProvidentLayout>
  );
}
